import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

export interface Props {
  children?: any;
  className?: string;
  height: number;
  width: number;
  viewBox?: string;
}

class ResponsiveSVG extends React.Component<Props, any> {
  public render() {
    const { children, className, viewBox } = this.props;

    return (
      <svg className={className} {...viewBox && { viewBox }}>
        {children}
      </svg>
    );
  }
}

export default styled(ResponsiveSVG)`
  width: 100%;
  height: auto;
  overflow: hidden;
`;
